import {Center, FlexProps, Stack} from '@chakra-ui/react';
import {GeoIconNav} from 'components/icons/GeoIconNav';
import React from 'react';

export interface GeoMobileNavProps extends FlexProps {
	listLink?: any[];
}

export const GeoMobileNav: React.FC<GeoMobileNavProps> = ({
	listLink
}: GeoMobileNavProps) => (
	<Center as='nav' pt={2} width='100vw' boxShadow='md' bg='white'>
		<Stack direction='row' spacing={3}>
			{listLink.map(({src, link, label}) => {
				return <GeoIconNav key={src} src={src} link={link} label={label} />;
			})}
		</Stack>
	</Center>
);
